import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Category } from './category'

export class CategoriesRepository extends BaseRepository<Category> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.prospectApiUrl + '/' + 'categories', token, cache)
    }
}
